export default "__VITE_ASSET__CTE9oB8W__"